(() => {
  const PALETTE_HEX_BY_CODE = {"0": "#ffffff", "1": "#68303e", "2": "#8e3954", "3": "#ca3b5e", "4": "#c22f5a", "5": "#c02143", "6": "#e451af", "7": "#de7fab", "8": "#e077a7", "9": "#ef96c3", "10": "#ee004f", "11": "#ed0051", "12": "#f03858", "13": "#ef497a", "14": "#ef5953", "15": "#e20000", "16": "#f03260", "17": "#e2ace0", "18": "#e7a8c1", "21": "#cc7e5c", "22": "#e45254", "23": "#e47c3a", "24": "#eea135", "25": "#efaf7a", "26": "#efae49", "27": "#eecca8", "28": "#efb08b", "29": "#efb37e", "31": "#d29131", "32": "#e08d35", "33": "#e1ae39", "34": "#f0be35", "35": "#ebc800", "36": "#ec8c46", "37": "#e7ca00", "38": "#e0d61b", "41": "#c7a547", "42": "#7f734e", "43": "#2c7f4d", "44": "#dec568", "45": "#dad500", "46": "#00b66f", "47": "#00cc4a", "48": "#a7cd00", "49": "#ecbe2d", "50": "#00706f", "51": "#2e3b3b", "52": "#007b56", "53": "#007b6c", "54": "#00775f", "55": "#00c263", "56": "#00b35c", "57": "#00958b", "58": "#21d1b4", "59": "#00cc70", "61": "#008c9f", "62": "#12496d", "63": "#009bc0", "64": "#0090b1", "65": "#00bbc3", "66": "#00a0b3", "67": "#00aeca", "68": "#00a2ad", "69": "#244477", "70": "#005ca5", "71": "#00559d", "72": "#194b94", "73": "#5f50a3", "74": "#4985d8", "75": "#bcbee5", "76": "#1daeed", "77": "#d9ceea", "81": "#82459a", "82": "#9b46a6", "83": "#8766cd", "84": "#e0a4cd", "85": "#b0409d", "86": "#be338c", "87": "#c9348a", "88": "#e38acb", "89": "#dc78b5", "91": "#894c4c", "92": "#9f5b43", "93": "#b06e64", "94": "#9c5757", "95": "#8b5949", "96": "#b06852", "97": "#cb8279", "98": "#765151", "99": "#7b5e55", "100": "#a57243", "101": "#b38153", "102": "#936c52", "103": "#c2615d", "104": "#be9a54", "107": "#efa763", "109": "#e1d5bd", "120": "#000000", "121": "#ef418a", "122": "#ef5a6a", "123": "#dade83", "124": "#aedf7d", "125": "#ef3993", "126": "#ef55a7", "131": "#e9dab2", "132": "#efc99d", "133": "#efb96e", "134": "#efb766", "135": "#eacbaf", "136": "#ebcae2", "137": "#e883bf", "138": "#eecee1", "139": "#ebc281", "140": "#ef7e74", "141": "#e9bf7b", "142": "#e2cd98", "143": "#bce5e0", "144": "#91ccee", "145": "#e9d9e2", "146": "#dac6e2", "147": "#e6bbde", "163": "#d4e5ab", "164": "#e8d36d", "166": "#b3dfa9", "167": "#91db7b", "169": "#d8d3ba", "171": "#c1e1e3", "172": "#c5e3e0", "173": "#e7e1b9", "174": "#decd95", "175": "#a9d2a5", "178": "#92dfda", "179": "#00d3c1", "182": "#b8e6e0", "183": "#32b2f0", "185": "#8ccaeb", "196": "#e7d9e4", "198": "#e4a7d0", "BG1": "#cbccd2", "BG3": "#a0c1cb", "BG5": "#83a6b0", "BG7": "#598488", "BG9": "#30585e", "CG05": "#e4e7e6", "CG1": "#e2d9dc", "CG2": "#c7cbd3", "CG3": "#cecbcf", "CG4": "#bab7b8", "CG5": "#b1aab0", "CG6": "#868f94", "CG7": "#69747f", "CG8": "#5b6570", "CG9": "#383b3f", "GG1": "#dde4e5", "GG3": "#d8d7dd", "GG5": "#929593", "GG7": "#6e7778", "GG9": "#49564d", "WG05": "#e0e0e0", "WG1": "#d8cfd2", "WG2": "#d0b7c6", "WG3": "#b8909e", "WG4": "#af8193", "WG5": "#ad8c94", "WG6": "#937882", "WG7": "#855f64", "WG8": "#775a65", "WG9": "#534547"};
  const PALETTE_FAMILY_BY_CODE = {"0": "neutros", "1": "rojos", "2": "rojos", "3": "rojos", "4": "rojos", "5": "rosas", "6": "rosas", "7": "rosas", "8": "rosas", "9": "rosas", "10": "rojos", "11": "rojos", "12": "rojos", "13": "rojos", "14": "rojos", "15": "rojos", "16": "rosas", "17": "rosas", "18": "pieles", "21": "cafes", "22": "rojos", "23": "naranjos", "24": "naranjos", "25": "rosas", "26": "pieles", "27": "rosas", "28": "rosas", "29": "pieles", "31": "amarillos", "32": "amarillos", "33": "amarillos", "34": "amarillos", "35": "amarillos", "36": "pieles", "37": "amarillos", "38": "amarillos", "41": "verdes", "42": "cafes", "43": "verdes", "44": "verdes", "45": "amarillos", "46": "verdes", "47": "verdes", "48": "amarillos", "49": "verdes", "50": "verdes", "51": "verdes", "52": "verdes", "53": "verdes", "54": "verdes", "55": "verdes", "56": "verdes", "57": "verdes", "58": "verdes", "59": "verdes", "61": "verdes", "62": "azules", "63": "azules", "64": "azules", "65": "azules", "66": "azules", "67": "azules", "68": "azules", "69": "azules", "70": "azules", "71": "azules", "72": "azules", "73": "azules", "74": "azules", "75": "azules", "76": "azules", "77": "azules", "81": "violetas", "82": "violetas", "83": "violetas", "84": "rosas", "85": "violetas", "86": "rojos", "87": "violetas", "88": "grises", "89": "violetas", "91": "cafes", "92": "cafes", "93": "naranjos", "94": "cafes", "95": "cafes", "96": "cafes", "97": "pieles", "98": "cafes", "99": "cafes", "100": "cafes", "101": "cafes", "102": "cafes", "103": "cafes", "104": "grises", "107": "pieles", "109": "neutros", "120": "neutros", "121": "fluorescentes", "122": "fluorescentes", "123": "fluorescentes", "124": "fluorescentes", "125": "fluorescentes", "126": "fluorescentes", "131": "neutros", "132": "neutros", "133": "pieles", "134": "pieles", "135": "rosas", "136": "pieles", "137": "rosas", "138": "rosas", "139": "pieles", "140": "naranjos", "141": "amarillos", "142": "pieles", "143": "verdes", "144": "azules", "145": "violetas", "146": "grises", "147": "violetas", "163": "verdes", "164": "amarillos", "166": "verdes", "167": "verdes", "169": "pieles", "171": "verdes", "172": "verdes", "173": "verdes", "174": "verdes", "175": "verdes", "178": "grises", "179": "verdes", "182": "azules", "183": "azules", "185": "azules", "196": "rosas", "198": "rosas", "BG1": "grises", "BG3": "grises", "BG5": "grises", "BG7": "grises", "BG9": "grises", "CG05": "grises", "CG1": "grises", "CG2": "grises", "CG3": "grises", "CG4": "grises", "CG5": "grises", "CG6": "grises", "CG7": "grises", "CG8": "grises", "CG9": "grises", "GG1": "grises", "GG3": "grises", "GG5": "grises", "GG7": "grises", "GG9": "grises", "WG05": "grises", "WG1": "grises", "WG2": "grises", "WG3": "grises", "WG4": "grises", "WG5": "grises", "WG6": "grises", "WG7": "grises", "WG8": "grises", "WG9": "grises"};
  const PALETTE_NAME_BY_CODE = {"0": "Colorless Blender", "1": "Wine Red", "2": "Old Red", "3": "Rose Red", "4": "Vivid Red", "5": "Cherry Pink", "6": "Vivid Pink", "7": "Cosmos", "8": "Rose Pink", "9": "Pale Pink", "10": "Deep Red", "11": "Carmine", "12": "Coral Red", "13": "Scarlet", "14": "Vermilion", "15": "Geranium", "16": "Coral Pink", "17": "Pastel Pink", "18": "Peach", "21": "Terra Cotta", "22": "French Vermilion", "23": "Orange", "24": "Marigold", "25": "Salmon Pink", "26": "Pastel Peach", "27": "Powder Pink", "28": "Fruit Pink", "29": "Barely Beige", "31": "Dark Yellow", "32": "Deep Yellow", "33": "Melon Yellow", "34": "Yellow", "35": "Lemon Yellow", "36": "Cream", "37": "Pastel Yellow", "38": "Pale Yellow", "41": "Olive Green", "42": "Bronze Green", "43": "Deep Olive Green", "44": "Fresh Green", "45": "Canary Yellow", "46": "Vivid Green", "47": "Grass Green", "48": "Yellow Green", "49": "Pastel Green", "50": "Forest Green", "51": "Dark Green", "52": "Deep Green", "53": "Turquoise Green", "54": "Viridian", "55": "Emerald Green", "56": "Mint Green", "57": "Turquoise Green Light", "58": "Mint Green Light", "59": "Pale Green", "61": "Peacock Green", "62": "Marine Blue", "63": "Cerulean Blue", "64": "Indian Blue", "65": "Ice Blue", "66": "Baby Blue", "67": "Pastel Blue", "68": "Turquoise Blue", "69": "Prussian Blue", "70": "Royal Blue", "71": "Cobalt Blue", "72": "Napoleonic Blue", "73": "Ultra Blue", "74": "Brilliant Blue", "75": "Dark Blue", "76": "Sky Blue", "77": "Pale Blue", "81": "Deep Violet", "82": "Light Violet", "83": "Lavender", "84": "Pastel Pink", "85": "Vivid Purple", "86": "Vivid Reddish Purple", "87": "Azalea Purple", "88": "Purple Grey", "89": "Pale Purple", "91": "Natural Oak", "92": "Chocolate", "93": "Burnt Orange", "94": "Brick Brown", "95": "Burnt Sienna", "96": "Mahogany", "97": "Rose Beige", "98": "Chestnut Brown", "99": "Bronze", "100": "Walnut", "101": "Yellow Ochre", "102": "Raw Umber", "103": "Potato Brown", "104": "Brown Grey", "107": "Sand", "109": "Pearl White", "120": "Black", "121": "Fluorescent Coral Red", "122": "Fluorescent Orange", "123": "Fluorescent Yellow", "124": "Fluorescent Green", "125": "Fluorescent Rose", "126": "Fluorescent Pink", "131": "Pink White", "132": "Milky White", "133": "Baby Skin Pink", "134": "Raw Silk", "135": "Pale Cherry Pink", "136": "Blush", "137": "Medium Pink", "138": "Light Pink", "139": "Flesh", "140": "Light Orange", "141": "Buttercup Yellow", "142": "Pale Cream", "143": "Mint Blue", "144": "Pale Baby Blue", "145": "Pale Lavender", "146": "Mauve Shadow", "147": "Pale Lilac", "163": "Green Bice", "164": "Anise", "166": "Mignonette", "167": "Pale Green Light", "169": "Putty", "171": "Jade Green", "172": "Spectrum Green", "173": "Dim Green", "174": "Spring Dim Green", "175": "Lime Green", "178": "Cool Shadow", "179": "Aqua Mint", "182": "Frost Blue", "183": "Prussian Blue", "185": "Pale Blue Light", "196": "Pale Pink Light", "198": "Tender Pink", "BG1": "Blue Grey", "BG3": "Blue Grey", "BG5": "Blue Grey", "BG7": "Blue Grey", "BG9": "Blue Grey", "CG05": "Cool Grey", "CG1": "Cool Grey", "CG2": "Cool Grey", "CG3": "Cool Grey", "CG4": "Cool Grey", "CG5": "Cool Grey", "CG6": "Cool Grey", "CG7": "Cool Grey", "CG8": "Cool Grey", "CG9": "Cool Grey", "GG1": "Green Grey", "GG3": "Green Grey", "GG5": "Green Grey", "GG7": "Green Grey", "GG9": "Green Grey", "WG05": "Warm Grey", "WG1": "Warm Grey", "WG2": "Warm Grey", "WG3": "Warm Grey", "WG4": "Warm Grey", "WG5": "Warm Grey", "WG6": "Warm Grey", "WG7": "Warm Grey", "WG8": "Warm Grey", "WG9": "Warm Grey"};
  const FALLBACK_HEXES = ["#ffffff", "#68303e", "#8e3954", "#ca3b5e", "#c22f5a", "#c02143", "#e451af", "#de7fab", "#e077a7", "#ef96c3", "#ee004f", "#ed0051", "#f03858", "#ef497a", "#ef5953", "#e20000", "#f03260", "#e2ace0", "#e7a8c1", "#cc7e5c", "#e45254", "#e47c3a", "#eea135", "#efaf7a", "#efae49", "#eecca8", "#efb08b", "#efb37e", "#d29131", "#e08d35", "#e1ae39", "#f0be35", "#ebc800", "#ec8c46", "#e7ca00", "#e0d61b", "#c7a547", "#7f734e", "#2c7f4d", "#dec568", "#dad500", "#00b66f", "#00cc4a", "#a7cd00", "#ecbe2d", "#00706f", "#2e3b3b", "#007b56", "#007b6c", "#00775f", "#00c263", "#00b35c", "#00958b", "#21d1b4", "#00cc70", "#008c9f", "#12496d", "#009bc0", "#0090b1", "#00bbc3", "#00a0b3", "#00aeca", "#00a2ad", "#244477", "#005ca5", "#00559d", "#194b94", "#5f50a3", "#4985d8", "#bcbee5", "#1daeed", "#d9ceea", "#82459a", "#9b46a6", "#8766cd", "#e0a4cd", "#b0409d", "#be338c", "#c9348a", "#e38acb", "#dc78b5", "#894c4c", "#9f5b43", "#b06e64", "#9c5757", "#8b5949", "#b06852", "#cb8279", "#765151", "#7b5e55", "#a57243", "#b38153", "#936c52", "#c2615d", "#be9a54", "#efa763", "#e1d5bd", "#000000", "#ef418a", "#ef5a6a", "#dade83", "#aedf7d", "#ef3993", "#ef55a7", "#e9dab2", "#efc99d", "#efb96e", "#efb766", "#eacbaf", "#ebcae2", "#e883bf", "#eecee1", "#ebc281", "#ef7e74", "#e9bf7b", "#e2cd98", "#bce5e0", "#91ccee", "#e9d9e2", "#dac6e2", "#e6bbde", "#d4e5ab", "#e8d36d", "#b3dfa9", "#91db7b", "#d8d3ba", "#c1e1e3", "#c5e3e0", "#e7e1b9", "#decd95", "#a9d2a5", "#92dfda", "#00d3c1", "#b8e6e0", "#32b2f0", "#8ccaeb", "#e7d9e4", "#e4a7d0", "#cbccd2", "#a0c1cb", "#83a6b0", "#598488", "#30585e", "#e4e7e6", "#e2d9dc", "#c7cbd3", "#cecbcf", "#bab7b8", "#b1aab0", "#868f94", "#69747f", "#5b6570", "#383b3f", "#dde4e5", "#d8d7dd", "#929593", "#6e7778", "#49564d", "#e0e0e0", "#d8cfd2", "#d0b7c6", "#b8909e", "#af8193", "#ad8c94", "#937882", "#855f64", "#775a65", "#534547"];

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ñ/g, 'n')
      .trim();
  }

  function normalizeCode(value) {
    return String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  }

  function extractCode(title, sku) {
    const skuText = String(sku || '').trim();
    let match = skuText.match(/PBN-MK-([A-Z0-9.]+)/i) || skuText.match(/(?:^|[-\s])([A-Z]{1,3}\d(?:\.5)?|\d{1,3}|0)$/i);
    if (match) return normalizeCode(match[1]);
    const rawTitle = String(title || '').trim();
    match = rawTitle.match(/^(CG0\.5|WG0\.5|[A-Z]{1,3}\d(?:\.5)?|\d{1,3}|0)\b/i);
    if (match) return normalizeCode(match[1]);
    return normalizeCode(rawTitle.split(/\s+/)[0]);
  }

  function normalizeFamily(value) {
    const v = normalize(value).replace(/[^a-z0-9]+/g, '');
    const map = {
      all: 'all', todos: 'all',
      rojo: 'rojos', rojos: 'rojos', red: 'rojos', reds: 'rojos',
      rosa: 'rosas', rosas: 'rosas', pink: 'rosas', pinks: 'rosas',
      naranjo: 'naranjos', naranjos: 'naranjos', naranja: 'naranjos', naranjas: 'naranjos', orange: 'naranjos', oranges: 'naranjos',
      amarillo: 'amarillos', amarillos: 'amarillos', yellow: 'amarillos', yellows: 'amarillos',
      verde: 'verdes', verdes: 'verdes', green: 'verdes', greens: 'verdes',
      azul: 'azules', azules: 'azules', blue: 'azules', blues: 'azules',
      violeta: 'violetas', violetas: 'violetas', purple: 'violetas', purples: 'violetas', violet: 'violetas', violets: 'violetas',
      gris: 'grises', grises: 'grises', grey: 'grises', greys: 'grises', gray: 'grises', grays: 'grises',
      cafe: 'cafes', cafes: 'cafes', marron: 'cafes', marrones: 'cafes', brown: 'cafes', browns: 'cafes',
      piel: 'pieles', pieles: 'pieles', skin: 'pieles', flesh: 'pieles',
      neutro: 'neutros', neutros: 'neutros', neutral: 'neutros', neutrals: 'neutros', black: 'neutros', white: 'neutros',
      fluorescente: 'fluorescentes', fluorescentes: 'fluorescentes', fluorescent: 'fluorescentes'
    };
    return map[v] || v || 'otros';
  }

  function moneyFromCents(cents) {
    return '$' + Math.round(Number(cents || 0) / 100).toLocaleString('es-CL');
  }

  function colorTextForHex(hex) {
    const value = String(hex || '').replace('#', '').trim();
    if (!/^[0-9a-f]{6}$/i.test(value)) return '#071b3a';
    const r = parseInt(value.slice(0, 2), 16);
    const g = parseInt(value.slice(2, 4), 16);
    const b = parseInt(value.slice(4, 6), 16);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 150 ? '#071b3a' : '#ffffff';
  }

  function debounce(fn, wait) {
    let timeout;
    return (...args) => {
      window.clearTimeout(timeout);
      timeout = window.setTimeout(() => fn(...args), wait);
    };
  }

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function route(path) {
    const root = shopRoot();
    return root.replace(/\/$/, '') + path;
  }

  function updateCartCount(itemCount) {
    const count = Number(itemCount || 0);
    document.querySelectorAll('.cart-count-bubble').forEach(bubble => {
      bubble.style.display = '';
      const visible = bubble.querySelector('span[aria-hidden="true"]') || bubble.querySelector('span:not(.visually-hidden)');
      if (visible) visible.textContent = String(count);
      const hidden = bubble.querySelector('.visually-hidden');
      if (hidden) hidden.textContent = count === 1 ? '1 artículo' : `${count} artículos`;
    });
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { item_count: count } }));
    document.dispatchEvent(new CustomEvent('pbnm:cart-updated', { detail: { item_count: count } }));
  }

  async function fetchCart() {
    const res = await fetch(route('/cart.js'), { credentials: 'same-origin', headers: { 'Accept': 'application/json' }, cache: 'no-store' });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
  }

  async function refreshCartCount() {
    const cart = await fetchCart();
    updateCartCount(cart.item_count);
    return cart;
  }

  function getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const element = parsed.querySelector(selector);
    return element ? element.innerHTML : null;
  }

  function rebindCartDrawerOverlay() {
    const drawer = document.querySelector('cart-drawer');
    const overlay = drawer && drawer.querySelector('#CartDrawer-Overlay');
    if (!drawer || !overlay || overlay.dataset.pbnmOverlayReady === 'true') return;
    overlay.dataset.pbnmOverlayReady = 'true';
    overlay.addEventListener('click', () => {
      if (typeof drawer.close === 'function') drawer.close();
    });
  }

  function clearCartEmptyClasses() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    drawer.classList.remove('is-empty');
    const inner = drawer.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');
    drawer.querySelectorAll('cart-drawer-items.is-empty').forEach(el => el.classList.remove('is-empty'));
  }

  function renderCartSectionsFromResponse(parsedState, openAfter = false) {
    const sections = parsedState && parsedState.sections;
    const drawer = document.querySelector('cart-drawer');
    if (!sections) {
      if (openAfter && drawer && typeof drawer.open === 'function') drawer.open();
      return false;
    }

    // When opening, let Dawn do the full drawer render so focus, overlay and inner
    // empty-state classes stay synchronized.
    if (openAfter && drawer && typeof drawer.renderContents === 'function') {
      try {
        drawer.renderContents({ sections });
        return true;
      } catch (e) {
        console.warn('Dawn renderContents failed, falling back to manual render', e);
      }
    }

    const drawerContainer = document.getElementById('CartDrawer');
    if (drawerContainer && sections['cart-drawer']) {
      const html = getSectionInnerHTML(sections['cart-drawer'], '#CartDrawer');
      if (html !== null) drawerContainer.innerHTML = html;
    }

    const cartIcon = document.getElementById('cart-icon-bubble');
    if (cartIcon && sections['cart-icon-bubble']) {
      const html = getSectionInnerHTML(sections['cart-icon-bubble']);
      if (html !== null) cartIcon.innerHTML = html;
    }

    clearCartEmptyClasses();
    rebindCartDrawerOverlay();
    // Re-attach Dawn's header-cart click after replacing #cart-icon-bubble.
    if (drawer && typeof drawer.setHeaderCartIconAccessibility === 'function') {
      try { drawer.setHeaderCartIconAccessibility(); } catch (e) {}
    }
    if (openAfter && drawer && typeof drawer.open === 'function') {
      window.setTimeout(() => drawer.open(), 0);
    }
    return true;
  }

  async function fetchAndRenderCartSections(openAfter = false) {
    const sectionsUrl = `${route('/')}?sections=cart-drawer,cart-icon-bubble&_=${Date.now()}`;
    const res = await fetch(sectionsUrl, {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      cache: 'no-store'
    });
    if (!res.ok) throw new Error(await res.text());
    const sections = await res.json();
    renderCartSectionsFromResponse({ sections }, openAfter);
    return sections;
  }

  async function addOneItemFast(item) {
    const form = new FormData();
    form.append('id', String(item.id));
    form.append('quantity', String(Number(item.quantity || 1)));
    const res = await fetch(route('/cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      body: form,
      cache: 'no-store'
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json().catch(() => ({}));
  }

  async function addItemsFast(items) {
    const queue = items.slice();
    const workers = Array.from({ length: Math.min(4, queue.length) }, async () => {
      while (queue.length) {
        const item = queue.shift();
        await addOneItemFast(item);
      }
    });
    await Promise.all(workers);
  }


  async function openCart() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      try {
        await fetchAndRenderCartSections(true);
        return;
      } catch (e) {
        console.warn('Could not refresh cart drawer before open', e);
        try { drawer.open(); return; } catch (err) {}
      }
    }
    const notification = document.querySelector('cart-notification');
    if (notification && typeof notification.open === 'function') {
      try { notification.open(); return; } catch (e) {}
    }
    // Last resort: do nothing instead of navigating away from the product page.
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  function initMarkerPicker(root) {
    const cards = Array.from(root.querySelectorAll('[data-pbnm-variant-card]'));
    if (!cards.length) return;

    const search = root.querySelector('[data-pbnm-color-search]');
    const empty = root.querySelector('[data-pbnm-empty]');
    const familyBtns = Array.from(root.querySelectorAll('[data-pbnm-family]'));
    const countEls = Array.from(root.querySelectorAll('[data-pbnm-selected-count], [data-pbnm-sticky-total]'));
    const helpEls = Array.from(root.querySelectorAll('[data-pbnm-selected-help], [data-pbnm-sticky-help], [data-pbnm-panel-help]'));
    const panelTotal = root.querySelector('[data-pbnm-panel-total]');
    const addButtons = Array.from(root.querySelectorAll('[data-pbnm-add-selected]'));
    const statusEls = Array.from(root.querySelectorAll('[data-pbnm-add-status]'));
    let activeFamily = 'all';
    const selected = new Map();
    const pending = new Set();

    function setStatus(message, tone = 'neutral') {
      statusEls.forEach(el => {
        el.textContent = message || '';
        el.hidden = !message;
        el.dataset.tone = tone;
      });
    }

    async function syncCartDrawer(parsedState, openAfter = false) {
      try {
        if (parsedState && parsedState.sections) {
          renderCartSectionsFromResponse(parsedState, openAfter);
        } else {
          await fetchAndRenderCartSections(openAfter);
        }
      } catch (error) {
        console.warn('No se pudo refrescar el drawer', error);
      }
    }

    async function openCartDrawer() {
      setStatus('Abriendo carrito…', 'neutral');
      try {
        await fetchAndRenderCartSections(true);
        setStatus('', 'neutral');
      } catch (error) {
        console.error(error);
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          try { drawer.open(); setStatus('', 'neutral'); return; } catch (e) {}
        }
        setStatus('No pude abrir el carrito. Prueba nuevamente.', 'error');
      }
    }

    function setCardPending(card, isPending) {
      if (!card) return;
      const id = String(card.getAttribute('data-variant-id') || '');
      if (id) {
        if (isPending) pending.add(id);
        else pending.delete(id);
      }
      card.classList.toggle('is-syncing', isPending);
      card.querySelectorAll('button').forEach(btn => {
        if (btn.hasAttribute('data-pbnm-select-btn') && card.getAttribute('data-available') === 'false') return;
        btn.disabled = isPending;
      });
    }

    function cardIsPending(card) {
      return pending.has(String(card && card.getAttribute('data-variant-id') || ''));
    }

    function markerPropertiesFromCard(card) {
      const code = String(card && card.dataset.colorCode || '').trim();
      const name = String(card && card.dataset.markerName || '').trim();
      const hex = String(card && card.dataset.swatch || '').trim() || '#ffffff';
      return {
        '_pbn_marker_hex': code === '0' ? '#ffffff' : hex,
        '_pbn_marker_code': code,
        '_pbn_marker_name': name
      };
    }

    async function addVariantToCart(cardOrId, quantity = 1) {
      const isCard = cardOrId && typeof cardOrId.getAttribute === 'function';
      const id = isCard ? cardOrId.getAttribute('data-variant-id') : cardOrId;
      const body = {
        id: String(id),
        quantity: Number(quantity || 1),
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      };
      if (isCard) body.properties = markerPropertiesFromCard(cardOrId);
      const res = await fetch(route('/cart/add.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body),
        cache: 'no-store'
      });
      if (!res.ok) throw new Error(await res.text());
      return res.json().catch(() => ({}));
    }

    async function decreaseVariantInCart(id, quantity = 1) {
      const cart = await fetchCart();
      const line = (cart.items || []).find(item => String(item.variant_id) === String(id));
      if (!line) return cart;
      const nextQty = Math.max(0, Number(line.quantity || 0) - Number(quantity || 1));
      const res = await fetch(route('/cart/change.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          id: line.key,
          quantity: nextQty,
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname
        }),
        cache: 'no-store'
      });
      if (!res.ok) throw new Error(await res.text());
      return res.json().catch(() => ({}));
    }

    cards.forEach((card, index) => {
      const fallbackIndex = Number(card.getAttribute('data-fallback-index') || index);
      const title = card.getAttribute('data-variant-title') || '';
      const sku = card.getAttribute('data-sku') || '';
      const code = extractCode(title, sku);
      const hex = PALETTE_HEX_BY_CODE[code] || (code === '0' ? '#ffffff' : null) || FALLBACK_HEXES[fallbackIndex] || '#e11d48';
      const family = normalizeFamily(PALETTE_FAMILY_BY_CODE[code] || card.getAttribute('data-family') || 'otros');
      const exactName = PALETTE_NAME_BY_CODE[code] || '';
      const displayName = exactName || title.replace(new RegExp('^' + code + '\\s*'), '').trim();

      card.dataset.colorCode = code;
      card.dataset.swatch = hex;
      card.dataset.family = family;
      card.dataset.markerName = displayName;
      card.style.setProperty('--swatch', hex);
      const swatchEl = card.querySelector('.pbnm-swatch');
      const capText = colorTextForHex(hex);
      card.style.setProperty('--cap-text', capText);
      if (swatchEl) {
        swatchEl.style.background = hex;
        let label = swatchEl.querySelector('.pbnm-cap-label');
        if (!label) {
          label = document.createElement('span');
          label.className = 'pbnm-cap-label';
          swatchEl.appendChild(label);
        }
        label.innerHTML = `<strong>${code}</strong><small>${displayName}</small>`;
      }
      card.dataset.search = `${title} ${sku} ${code} ${exactName} ${family}`.toLowerCase();

      card.querySelectorAll('.pbnm-swatch-card__body > span').forEach(el => el.remove());

      const body = card.querySelector('.pbnm-swatch-card__body') || card;
      if (!card.querySelector('[data-pbnm-card-qty]')) {
        const qty = document.createElement('div');
        qty.className = 'pbnm-card-qty';
        qty.setAttribute('data-pbnm-card-qty', '');
        qty.hidden = true;
        qty.innerHTML = `
          <button type="button" data-pbnm-card-minus aria-label="Restar marcador">−</button>
          <span data-pbnm-card-qty-value>1</span>
          <button type="button" data-pbnm-card-plus aria-label="Sumar marcador">+</button>
        `;
        body.appendChild(qty);
      }
    });

    function selectedItems() { return Array.from(selected.values()); }
    function totalQuantity() { return selectedItems().reduce((sum, item) => sum + item.quantity, 0); }
    function totalCents() { return selectedItems().reduce((sum, item) => sum + item.quantity * item.priceCents, 0); }

    function updateUI() {
      const count = selected.size;
      const qty = totalQuantity();
      const total = moneyFromCents(totalCents());

      cards.forEach(card => {
        const id = String(card.getAttribute('data-variant-id') || '');
        const item = selected.get(id);
        const isSelected = Boolean(item);
        const isPending = pending.has(id);
        card.classList.toggle('is-selected', isSelected);
        card.classList.toggle('is-syncing', isPending);
        const btn = card.querySelector('[data-pbnm-select-btn]');
        const qtyBox = card.querySelector('[data-pbnm-card-qty]');
        const qtyValue = card.querySelector('[data-pbnm-card-qty-value]');
        if (btn && card.getAttribute('data-available') !== 'false') {
          btn.textContent = isPending ? 'Agregando…' : (isSelected ? 'En carrito ✓' : 'Agregar color');
          btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
          btn.disabled = isPending;
        }
        if (qtyBox) qtyBox.hidden = !isSelected;
        if (qtyValue) qtyValue.textContent = isSelected ? String(item.quantity) : '1';
        card.querySelectorAll('[data-pbnm-card-minus], [data-pbnm-card-plus]').forEach(btn => { btn.disabled = isPending; });
      });

      const countText = count === 0 ? '0 colores seleccionados' : `${count} color${count === 1 ? '' : 'es'} en carrito`;
      const helpText = count === 0 ? 'Toca “Agregar color” para agregar cada marcador al carrito.' : `${qty} marcador${qty === 1 ? '' : 'es'} agregado${qty === 1 ? '' : 's'} · Total ${total}`;
      countEls.forEach(el => el.textContent = countText);
      helpEls.forEach(el => el.textContent = helpText);
      if (panelTotal) panelTotal.textContent = count === 0 ? 'Elige tus colores' : `${countText} · ${total}`;
      addButtons.forEach(btn => {
        btn.disabled = count === 0;
        btn.textContent = count === 0 ? 'Elige colores' : 'Abrir carrito';
        btn.setAttribute('aria-label', count === 0 ? 'Elige colores' : 'Abrir carrito');
      });
    }

    function ensureSelected(card, quantity) {
      const id = String(card.getAttribute('data-variant-id') || '').trim();
      if (!id) return null;
      const existing = selected.get(id) || {
        id,
        title: card.getAttribute('data-variant-title') || 'Color seleccionado',
        priceCents: Number(card.getAttribute('data-price-cents') || 0),
        swatch: card.dataset.swatch || '#e11d48',
        quantity: 0
      };
      existing.quantity = Math.max(0, Number(quantity || 0));
      if (existing.quantity <= 0) selected.delete(id);
      else selected.set(id, existing);
      return existing;
    }

    async function syncAdd(card, amount = 1) {
      if (!card || card.getAttribute('data-available') === 'false' || cardIsPending(card)) return;
      const id = String(card.getAttribute('data-variant-id') || '').trim();
      if (!id) return;
      const before = selected.get(id) ? selected.get(id).quantity : 0;
      ensureSelected(card, before + amount);
      setCardPending(card, true);
      setStatus('Agregando marcador al carrito…', 'neutral');
      updateUI();
      try {
        const parsed = await addVariantToCart(card, amount);
        refreshCartCount().catch(() => {});
        await syncCartDrawer(parsed, false);
        setStatus(`${card.getAttribute('data-variant-title') || 'Color'} agregado al carrito.`, 'success');
      } catch (error) {
        console.error(error);
        ensureSelected(card, before);
        setStatus('No se pudo agregar ese color. Revisa stock y prueba otra vez.', 'error');
      } finally {
        setCardPending(card, false);
        updateUI();
      }
    }

    async function syncSubtract(card, amount = 1) {
      if (!card || cardIsPending(card)) return;
      const id = String(card.getAttribute('data-variant-id') || '').trim();
      if (!id) return;
      const before = selected.get(id) ? selected.get(id).quantity : 0;
      if (before <= 0) return;
      ensureSelected(card, before - amount);
      setCardPending(card, true);
      setStatus('Actualizando carrito…', 'neutral');
      updateUI();
      try {
        const parsed = await decreaseVariantInCart(id, amount);
        refreshCartCount().catch(() => {});
        await syncCartDrawer(parsed, false);
        setStatus(before - amount > 0 ? 'Cantidad actualizada en el carrito.' : 'Color removido del carrito.', 'success');
      } catch (error) {
        console.error(error);
        ensureSelected(card, before);
        setStatus('No se pudo actualizar ese color. Prueba nuevamente.', 'error');
      } finally {
        setCardPending(card, false);
        updateUI();
      }
    }

    function filterCards() {
      const q = normalize(search && search.value || '');
      let visible = 0;
      cards.forEach(card => {
        const text = normalize(card.dataset.search || '');
        const family = normalizeFamily(card.dataset.family || 'otros');
        const okText = !q || text.includes(q);
        const okFamily = activeFamily === 'all' || family === activeFamily;
        const show = okText && okFamily;
        card.classList.toggle('is-hidden', !show);
        card.hidden = !show;
        card.style.display = show ? '' : 'none';
        if (show) visible += 1;
      });
      if (empty) empty.classList.toggle('is-visible', visible === 0);
    }

    cards.forEach(card => card.addEventListener('click', e => {
      const minus = e.target.closest('[data-pbnm-card-minus]');
      const plus = e.target.closest('[data-pbnm-card-plus]');
      const selectBtn = e.target.closest('[data-pbnm-select-btn]');
      if (minus || plus || selectBtn) e.preventDefault();
      if (minus) return syncSubtract(card, 1);
      if (plus) return syncAdd(card, 1);
      // The whole card acts as the add button, including the visible CTA.
      return syncAdd(card, 1);
    }));

    familyBtns.forEach(btn => btn.addEventListener('click', () => {
      activeFamily = normalizeFamily(btn.getAttribute('data-pbnm-family') || 'all');
      familyBtns.forEach(b => b.classList.toggle('is-active', b === btn));
      filterCards();
    }));

    if (search) search.addEventListener('input', debounce(filterCards, 80));
    addButtons.forEach(btn => btn.addEventListener('click', openCartDrawer));
    root.querySelectorAll('[data-pbnm-open-cart]').forEach(btn => btn.addEventListener('click', e => { e.preventDefault(); openCartDrawer(); }));

    filterCards();
    updateUI();
  }


  function initPbnmGalleries() {
    document.querySelectorAll('[data-pbnm-gallery]').forEach(gallery => {
      if (gallery.dataset.pbnmGalleryReady === 'true') return;
      gallery.dataset.pbnmGalleryReady = 'true';
      const main = gallery.querySelector('[data-pbnm-main-image]');
      const thumbs = Array.from(gallery.querySelectorAll('[data-pbnm-thumb]'));
      if (!main || !thumbs.length) return;
      thumbs.forEach(thumb => {
        thumb.addEventListener('click', () => {
          const src = thumb.getAttribute('data-full-src');
          const alt = thumb.getAttribute('data-alt') || main.getAttribute('alt') || '';
          if (!src) return;
          main.src = src;
          main.srcset = '';
          main.alt = alt;
          thumbs.forEach(t => t.classList.toggle('is-active', t === thumb));
        });
      });
    });
  }

  function initPbnmAjaxProductForms() {
    document.querySelectorAll('[data-pbnm-ajax-product-form]').forEach(form => {
      if (form.dataset.pbnmAjaxReady === 'true') return;
      form.dataset.pbnmAjaxReady = 'true';
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        const wrapper = form.closest('.pbnm-page') || document;
        const statusEls = Array.from(wrapper.querySelectorAll('[data-pbnm-add-status]'));
        const originalText = button ? button.textContent : '';
        const setStatus = (message, tone = 'neutral') => statusEls.forEach(el => {
          el.textContent = message || '';
          el.hidden = !message;
          el.dataset.tone = tone;
        });
        if (button) { button.disabled = true; button.textContent = 'Agregando…'; }
        setStatus('Agregando al carrito…', 'neutral');
        try {
          const fd = new FormData(form);
          const shouldOpenAfterAdd = form.getAttribute('data-pbnm-open-after-add') === 'true';
          const res = await fetch(route('/cart/add.js'), {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: fd,
            cache: 'no-store'
          });
          if (!res.ok) throw new Error(await res.text());
          setStatus('Agregado al carrito.', 'success');
          if (button) button.textContent = 'Agregado ✓';
          await refreshCartCount().catch(() => {});
          await fetchAndRenderCartSections(shouldOpenAfterAdd).catch(() => {});
          window.setTimeout(() => {
            if (button) { button.disabled = false; button.textContent = originalText || 'Agregar al carrito'; }
          }, 900);
        } catch (error) {
          console.error(error);
          setStatus('No se pudo agregar. Prueba otra vez.', 'error');
          if (button) { button.disabled = false; button.textContent = originalText || 'Agregar al carrito'; }
        }
      });
    });
  }

  if (!window.__pbnmOpenCartCaptureReady) {
    window.__pbnmOpenCartCaptureReady = true;
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-pbnm-open-cart], #cart-icon-bubble, .header__icon--cart');
      if (!trigger) return;
      const href = trigger.getAttribute && trigger.getAttribute('href');
      const isCartHref = href && /\/cart(?:$|[?#])/.test(href);
      const isPbn = trigger.hasAttribute && trigger.hasAttribute('data-pbnm-open-cart');
      const isHeaderCart = trigger.id === 'cart-icon-bubble' || trigger.classList.contains('header__icon--cart');
      if (!isPbn && !isHeaderCart && !isCartHref) return;
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      openCart();
    }, true);
  }

  function boot() {
    initPbnmGalleries();
    initPbnmAjaxProductForms();
    document.querySelectorAll('[data-pbnm-marker-picker]').forEach(root => {
      if (root.dataset.pbnmPickerReady === 'true') return;
      root.dataset.pbnmPickerReady = 'true';
      initMarkerPicker(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

(function(){
  function initPbnmSetQuantitySteppers(){
    document.querySelectorAll('[data-pbnm-set-qty-stepper]').forEach(stepper => {
      if (stepper.dataset.pbnmQtyReady === 'true') return;
      stepper.dataset.pbnmQtyReady = 'true';
      const page = stepper.closest('.pbnm-page') || document;
      const input = stepper.querySelector('[data-pbnm-set-quantity]');
      const minus = stepper.querySelector('[data-pbnm-set-qty-minus]');
      const plus = stepper.querySelector('[data-pbnm-set-qty-plus]');
      if (!input) return;
      const sync = (value) => {
        const qty = Math.max(1, parseInt(value, 10) || 1);
        page.querySelectorAll('[data-pbnm-set-quantity]').forEach(el => { el.value = String(qty); });
      };
      minus && minus.addEventListener('click', (event) => { event.preventDefault(); event.stopPropagation(); sync((parseInt(input.value, 10) || 1) - 1); });
      plus && plus.addEventListener('click', (event) => { event.preventDefault(); event.stopPropagation(); sync((parseInt(input.value, 10) || 1) + 1); });
      input.addEventListener('change', () => sync(input.value));
      input.addEventListener('input', () => sync(input.value));
      sync(input.value);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPbnmSetQuantitySteppers);
  else initPbnmSetQuantitySteppers();
  document.addEventListener('shopify:section:load', initPbnmSetQuantitySteppers);
})();
